<template>
  <div>
    <vs-button :type="buttonType" :class="buttonClass" @click.stop="showSecondaryMarketPopUp">{{ buttonText
    }}</vs-button>
    <!-- POP-UP SOBRE INVITACION AL MERCADO SECUNDARIO -->
    <vs-popup :active.sync="popUpSecondaryMarketInvitationActive" :title="popUpSecondaryMarketInvitationTitleDynamic"
      class="header-primary mid-popup">
      <div v-if="popUpSecondaryMarketInvitationActive" class="vx-row">
        <div class="vx-col w-full p-10">
          <div v-if="popUpSecondaryMarketStep == 1">
            <p>
              Este nuevo contrato te permitiriá <b>diversificar</b> tu inversión y obtener <b>liquidez
                anticipada</b>
              (mercado secundario).
              <br><br>
              Estas son las nuevas comisiones:
            </p>
            <div class="vx-row">
              <div class="vx-col w-full" style="height:300px; overflow-y:scroll">
                <vs-table class="mt-base" noDataText="" :data="[]">
                  <template>
                    <vs-tr>
                      <vs-td class="bold">Comisión</vs-td>
                      <vs-td class="bold">Antes</vs-td>
                      <vs-td class="bold">Ahora</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="bold">Éxito</vs-td>
                      <vs-td>2% del <b>total</b> pagado<br> (rendimiento + capital) </vs-td>
                      <vs-td><span style="text-decoration: line-through;">10%</span> 0%* solo del <b>rendimiento</b>
                        pagado</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="bold">Transacción</vs-td>
                      <vs-td>N/A</vs-td>
                      <vs-td>2% del retiro por <b>liquidez <br> anticipada**</b></vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="bold">Aclaración <br> improcedente</vs-td>
                      <vs-td>N/A</vs-td>
                      <vs-td>$500 por caso</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="bold">Contracargo <br> improcedente</vs-td>
                      <vs-td>N/A</vs-td>
                      <vs-td>$500 por caso</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <small>
                  <p>
                    *Los inversionistas que firmen el nuevo contrato gozarán de una comisión por éxito del 0%
                    indefinidamente.
                  </p>
                  <p>
                    **Solo aplica para liquidez obtenida en mercado secundario. Retirar tu saldo disponible no genera
                    comisión.
                  </p>
                  <p>
                    Los cambios en las comisiones aplicarán a partir de que firmes tu nuevo contrato.
                  </p>
                  <p>Todas las <a class="inline-link" href="https://www.redgirasol.com/comisiones" target="_blank"
                      rel="noopener">comisiones</a> son más IVA.</p>
                </small>
              </div>
            </div>
            <div class="flex flex-wrap justify-center">
              <vs-button class="mt-5" color="dark" @click.stop="popUpSecondaryMarketStep++">Continuar</vs-button>
            </div>
          </div>
          <template v-if="popUpSecondaryMarketStep == 2">
            <div class="vx-row">
              <div class="vx-col w-full" style="height:400px; overflow-y:scroll">
                <latest-investor-merchant-contract :fill-user-data="true" />
              </div>
            </div>
            <div class="flex flex-wrap justify-center">
              <vs-button class="mt-base" color="dark" @click.stop="popUpSecondaryMarketStep++">Firmar</vs-button>
            </div>
          </template>
          <template v-if="popUpSecondaryMarketStep == 3">
            <div class="vx-row">
              <div class="vx-col w-full">
                <h5>Mercado secundario</h5>
                <p class="mt-5">
                  Solicito a RedGirasol participar en el mercado secundario para diversificar mis inversiones y
                  tener la posibilidad de obtener liquidez anticipada.
                </p>
                <div class="checkbox-display mt-5">
                  <vs-checkbox name="terms" v-model.lazy="acceptSecondaryMarketTerms">
                  </vs-checkbox>
                  <p>Entiendo y estoy de acuerdo con los <br>
                    <a class="inline-link-regular" target="_blank" rel="noopener"
                      @click="popUpSecondaryMarketTermsContract = true">Términos y Condiciones del Mercado
                      Secundario</a>.
                  </p>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap justify-center">
              <vs-button class="mt-base" color="dark" :disabled="!acceptSecondaryMarketTerms"
                @click.stop="signSecondaryMarketContracts">Autorizar y continuar</vs-button>
            </div>
          </template>
        </div>
      </div>
      <!-- Popup para ver terminos y condiciones de mercado secundario -->
      <vs-popup :active.sync="popUpSecondaryMarketTermsContract" title="Términos y condiciones"
        class="extended-popup header-primary">
        <latest-secondary-market-terms-conditions-contract v-if="popUpSecondaryMarketTermsContract" />
      </vs-popup>
    </vs-popup>

    <!-- Componente para obtener la geolocalización -->
    <rg-geolocator ref="rgGeolocator" />
  </div>
</template>

<script>
import investorInfoHelper from "@/helpers/investorInfoHelper";
import LatestInvestorMerchantContract from "@views/investor/contracts/LatestInvestorMerchantContract.vue";
import LatestSecondaryMarketTermsConditionsContract from "@views/investor/contracts/LatestSecondaryMarketTermsConditionsContract.vue";

export default {
  components: {
    LatestInvestorMerchantContract,
    LatestSecondaryMarketTermsConditionsContract
  },
  mixins: [investorInfoHelper],
  name: 'SignSecondaryMarketContractBtn',
  props: {
    buttonText: {
      type: String,
      default: "Firmar nuevo contrato",
    },
    buttonEffect: {
      type: Boolean,
      default: false
    },
    buttonType: {
      type: String,
      default: "filled"
    },
  },
  data() {
    return {
      popUpSecondaryMarketTermsContract: false,
      popUpSecondaryMarketInvitationTitle: "",
      popUpSecondaryMarketInvitationActive: false,
      popUpSecondaryMarketStep: 1,
      acceptSecondaryMarketTerms: false
    }
  },
  computed: {
    buttonClass() {
      return this.buttonEffect ? "pulse-success" : "";
    },
    popUpSecondaryMarketInvitationTitleDynamic() {
      let title = "";
      switch (this.popUpSecondaryMarketStep) {
        case 0:
        case 1:
        case 2:
          title = "Tu nuevo contrato";
          break;
        case 3:
          title = "Consentimiento";
          break;
        default:
          break;
      }
      return title;
    },
  },
  watch: {
    popUpSecondaryMarketInvitationActive: function (newv, oldv) {
      if (newv === false) {
        this.popUpSecondaryMarketStep = 1;
      }
    }
  },
  methods: {
    showSecondaryMarketPopUp() {
      // se pide la geolocalizacion para la operacion
      this.$refs.rgGeolocator.askForGeolocation();
      this.popUpSecondaryMarketInvitationActive = true;
    },
    async signSecondaryMarketContracts() {
      this.showLoading(true, "Guardando información...");
      try {
        const payload = { geolocation: this.CurrentGeolocationData }
        await axios.post(`/api/v2/investor/${this.InvestorId}/sign-secondary-market-contracts`, payload);
        this.popUpSecondaryMarketInvitationActive = false;
        this.showLoading(false);
        this.$emit('on-signed', 1);
      } catch (e) {
        this.showLoading(false);
        this.errorNotifDialog("Error en la operación", e);
      }
    }
  }
}
</script>
